'use strict';

wbApp.directive('wbRecipientGroupCombo', ['$timeout', '$translate',
    function ($timeout, $translate) {

        function formatResult(item) {
            if (!item) { return; }

            return "<div class='row' style='width:100%'>" +
                       "<div class='col-md-5'>" + $translate.instant(item.text) + "</div>" +
                       "<div class='col-md-7'>" + $translate.instant(item.description) + "</div>" +
                  "</div>";

        }

        function formatSelection(item) {
            return '{0} ({1})'.f(
                $translate.instant(item.text),
                $translate.instant(item.description));
        }


        return {
            restrict: 'A',
            require: 'ngModel',
            replace: true,
            priority: 1,
            link: function (scope, elm, attrs, controller) {
                $timeout(function () {
                    $(elm).select2({
                        minimumResultsForSearch: -1,
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        data: [
                            { id: 1, text: 'TXT_VAL_RCPG_USER', description: 'TXT_DESC_RCPG_USER' },
                            { id: 17, text: 'TXT_VAL_RCPG_ACTION', description: 'TXT_DESC_RCPG_ACTION' },
                            { id: 2, text: 'TXT_VAL_RCPG_COURSE', description: 'TXT_DESC_RCPG_COURSE' },
                            { id: 3, text: 'TXT_VAL_RCPG_COURSE_LESSON', description: 'TXT_DESC_RCPG_COURSE_LESSON' },
                            { id: 4, text: 'TXT_VAL_RCPG_CLASSROOM', description: 'TXT_DESC_RCPG_CLASSROOM' },
                            { id: 5, text: 'TXT_VAL_RCPG_CLASSROOM_AT_DATE', description: 'TXT_DESC_RCPG_CLASSROOM_AT_DATE' },
                            { id: 6, text: 'TXT_VAL_RCPG_COMPENSATION_GROUP', description: 'TXT_DESC_RCPG_COMPENSATION_GROUP' },
                            { id: 7, text: 'TXT_VAL_RCPG_ALL_COURSES', description: 'TXT_DESC_RCPG_ALL_COURSES' },
                            { id: 8, text: 'TXT_VAL_RCPG_ALL_ACTIONS', description: 'TXT_DESC_RCPG_ALL_ACTIONS' },
                            { id: 9, text: 'TXT_VAL_RCPG_ALL_ACTIONS_WITHOUT_COURSES', description: 'TXT_DESC_RCPG_ALL_ACTIONS_WITHOUT_COURSES' },
                            { id: 10, text: 'TXT_VAL_RCPG_SEMESTER', description: 'TXT_DESC_RCPG_SEMESTER' },
                            { id: 11, text: 'TXT_VAL_RCPG_NOT_IN_SEMESTER', description: 'TXT_DESC_RCPG_NOT_IN_SEMESTER' },
                            { id: 12, text: 'TXT_VAL_RCPG_NOT_IN_SEMESTER_ATTENDING_LAST_ONE', description: 'TXT_DESC_RCPG_NOT_IN_SEMESTER_ATTENDING_LAST_ONE' },
                            { id: 13, text: 'TXT_VAL_RCPG_NOT_IN_SEMESTR_NO_ACTIONS', description: 'TXT_DESC_RCPG_NOT_IN_SEMESTR_NO_ACTIONS' },
                            { id: 14, text: 'TXT_VAL_RCPG_NOT_IN_SEMESTR_NO_ACTIONS_ATTENDING_LAST_ONE', description: 'TXT_DESC_RCPG_NOT_IN_SEMESTR_NO_ACTIONS_ATTENDING_LAST_ONE' },
                            { id: 15, text: 'TXT_VAL_RCPG_ALL_AT_DATE', description: 'TXT_DESC_RCPG_ALL_AT_DATE' },
                            { id: 16, text: 'TXT_VAL_RCPG_STUDENT', description: 'TXT_DESC_RCPG_STUDENT' },
                            { id: 18, text: 'TXT_VAL_RCPG_ALL', description: 'TXT_DESC_RCPG_ALL' },
                        ]
                    });

                    elm.on('change', function (event) {
                        scope.$apply(function () {
                            controller.$setViewValue(event.val);
                        });
                    });

                    scope.$watch(attrs.ngModel, function (current, old) {
                        $(elm).select2('val', current);
                    }, true);

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    if (attrs.ngEnable) {
                        scope.$watch(attrs.ngEnable, function (newVal) {
                            elm.select2('enable', !!newVal);
                        });
                    }
                }, 1);
            }
        }
    }]);
